import styled from "styled-components";
import {CheckIcon, IconBadge, MailIcon, PillButton, tokens} from "ui/blocks/guestMessaging/GuestUI";

/** Shown only after the backend confirmed the guest's message was delivered. */
export const GuestMessageSent = ({instructorName, email, onDone}) => (
    <Wrap role="status">
        <IconBadge>
            <CheckIcon size={30} strokeWidth={2.5}/>
        </IconBadge>
        <Title>Message sent!</Title>
        <Body>We'll email you when {instructorName} replies.</Body>
        {email && (
            <EmailChip>
                <MailIcon size={16}/>
                <span>{email}</span>
            </EmailChip>
        )}
        <PillButton type="button" $block onClick={onDone}>Done</PillButton>
    </Wrap>
);

const Wrap = styled.div`
    box-sizing: border-box;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: 12px;
    padding: 8px 8px 0;
    font-family: var(--font-primary);

    > button {
        margin-top: 12px;
    }
`;

const Title = styled.h2`
    margin: 8px 0 0;
    font-size: 24px;
    font-weight: 600;
    color: ${tokens.ink};
`;

const Body = styled.p`
    margin: 0;
    font-size: 16px;
    line-height: 1.5;
    color: ${tokens.text};
    max-width: 320px;
    text-wrap: balance;
`;

const EmailChip = styled.div`
    display: inline-flex;
    align-items: center;
    gap: 8px;
    max-width: 100%;
    padding: 8px 14px;
    border-radius: 100px;
    background: ${tokens.warm};
    color: ${tokens.muted};
    font-size: 14px;

    span {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
`;
